<template>
  <div class="outBox">
    <div class="topBox">
      <div class="headerBox">
        <div class="left-box">
          <img
              :src="liveData.roomShowUrl"
              alt="">

        </div>
        <div class="right-box">
          <div class="right-box-title">{{ liveData.roomName }}</div>
          <div class="right-box-time" style="display: flex;justify-content: space-between">
            <div>
              学习人数：{{ liveData.liveCount }}
            </div>
            <div>
              <el-rate v-model="star" disabled></el-rate>
            </div>
          </div>
          <div class="right-box-time">直播时间：
            {{ formattedLiveTime }}
          </div>
          <div class="right-box-time">
            <div class="right-box-free">
              免费
            </div>
          </div>
          <div class="right-box-look" @click="joinLive">
            观看回放
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBox">
      <div class="bottomBox-flex">
        <div class="left-box">
          <div>
            课程概述
          </div>
          <div>
            <!--            <div>课程简介</div>-->
            <div v-html="liveData.description">
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="right-box-teacher">
            <div><img :src="teacherData.picture" alt=""></div>
            <div>
              <div>{{ teacherData.name }}</div>
              <div>{{ teacherData.introduce }}</div>
            </div>
          </div>
          <div class="right-box-recomme">
            <div>
              <div>推荐课程</div>
              <div class="right-box-recomme-list">
                <div v-for="item in recommendList" :key="item.id" @click="goCourseDetails(item.id)">
                  <div>
                    <img :src="item.roomShowUrl" alt="">
                  </div>
                  <div>
                    <div>{{ item.roomName }}</div>
                    <div>{{ item.userName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
* {
  padding: 0;
  margin: 0;
}


.outBox {
  background: #ededed;
  padding: 10px 0;
  overflow: hidden;

  .topBox {
    width: 1200px;
    background: white;
    margin: auto;
    padding: 10px 0;
    border-radius: 5px;

    .headerBox {
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      justify-content: center;

      .left-box {
        width: 514px;
        height: 265px;


        img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
      }

      .right-box {
        width: 600px;
        margin-left: 25px;
        display: flex;
        flex-direction: column;

        .right-box-title {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .right-box-share {
          font-size: 14px;
          color: #666;
          margin: 10px 0 15px 0;
        }

        .right-box-time {
          font-size: 16px;
          color: #666;
          margin-bottom: 10px;

          .right-box-free {
            width: 100%;
            font-size: 28px;
            color: #5fb41b;
            background-color: #f8f9fa;
            padding: 10px;
            border-radius: 5px;
          }
        }

        .right-box-look {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100px;
          margin-top: auto; /* 关键：让按钮自动占据剩余空间，推到最下方 */
          font-size: 20px;
          border-radius: 8px;
          border: 1px solid #2a84e9;
          padding: 5px 10px;
          background-color: #edf4fe !important;
          color: #2a84e9;
          cursor: pointer;
        }

        .noOk {
          background-color: #ff7800 !important;
          color: #fff;
          cursor: not-allowed;
          border: 1px solid #ff7800;
        }

        .outOk {
          background-color: #ededed !important;
          color: #726f6f;
          cursor: not-allowed;
          border: 1px solid #ededed;
        }
      }
    }
  }
}

.bottomBox {
  width: 1200px;
  margin: 15px auto auto;

  .bottomBox-flex {
    display: flex;
    align-items: stretch;
    justify-content: center;
    margin: auto;

    .left-box {
      background: white;
      width: 850px;
      border-radius: 3px;

      > div:nth-child(1) {
        font-size: 18px;
        padding: 10px;
        border-bottom: 1px solid #ededed;
      }

      > div:nth-child(2) {
        padding: 10px;

        //> div:nth-child(1) {
        //  font-size: 16px;
        //  font-weight: bold;
        //  margin-bottom: 10px;
        //}
      }
    }

    .right-box {
      width: 346px;
      margin-left: 15px;


      .right-box-teacher {
        display: flex;
        background: white;
        padding: 15px;
        border-radius: 3px;

        > div:nth-child(1) {
          > img {
            width: 65px;
            height: 65px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        > div:nth-child(2) {
          > div:nth-child(1) {
            margin-bottom: 5px;
            font-size: 16px;
            font-weight: bold;
          }

          > div:nth-child(2) {
            display: block;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.5em;
            max-height: 4.5em; /* 1.5em × 3行 */
          }
        }
      }

      .right-box-recomme {
        margin-top: 10px;
        background: white;
        border-radius: 4px;

        > div {
          padding: 15px;
        }

        .right-box-recomme-list {
          margin-top: 10px;

          > div {
            display: flex;
            align-items: flex-start;
            justify-content: left;
            margin-bottom: 10px;
            cursor: pointer;

            > div:nth-child(1) {
              margin-right: 5px;

              > img {
                width: 80px;
                height: 47px;
                border-radius: 5px;
              }
            }

            > div:nth-child(2) {
              flex: 1;
              min-width: 0; /* 关键修复 */

              > div:nth-child(1) {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: 5px;
                font-weight: 550;
              }

              > div:nth-child(2) {
                font-size: 12px;
                color: #999;
              }
            }
          }

          > div:hover {
            > div:nth-child(1) {
              margin-right: 5px;

              > img {
                transform: scale(1.1); /* 放大1.1倍 */
                transition: transform 0.3s ease; /* 添加平滑过渡效果 */
              }
            }

            > div:nth-child(2) {
              > div:nth-child(1) {
                color: #ff7800;
              }
            }
          }
        }
      }
    }

  }
}
</style>

<script>
import {getTeacherByUserId, getListLivestream, joinChannel, getLiveLiveReplayById} from "@/api/live";

export default {
  data() {
    return {
      star: 5,
      liveData: {},
      teacherData: {},
      recommendList: [],
      liveState: null, //0未开始 1直播中 2已结束
      recorder: null,
      videoData: [],
      errorMessage: null,
      fileName: null,
      events: [],
      playbackDataFalg: false,
    }
  },
  computed: {
    formattedLiveTime() {
      if (!this.liveData.livesteramTime || !this.liveData.livesteramEndTime) return '';

      const start = new Date(this.liveData.livesteramTime);
      const end = new Date(this.liveData.livesteramEndTime);

      // 判断是否同年同月同日
      const isSameDay = start.getFullYear() === end.getFullYear() &&
          start.getMonth() === end.getMonth() &&
          start.getDate() === end.getDate();

      // 格式化日期时间（补零）
      const formatDateTime = (date, showFullDate) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        // const seconds = String(date.getSeconds()).padStart(2, '0');

        if (showFullDate) {
          return `${year}-${month}-${day} ${hours}:${minutes}`;//:${seconds}
        } else {
          return `${hours}:${minutes}`;//:${seconds}
        }
      };

      // 如果同年同月同日，结束时间省略年月日；否则显示完整格式
      return `${formatDateTime(start, true)} - ${formatDateTime(end, !isSameDay)}`;
    }
  },
  mounted() {
    getLiveLiveReplayById({roomId: this.$route.query.id}).then(res => {
      if (res.code === 200) {
        this.liveData = res.data
        const timestamp_ms = Date.now(); // 毫秒级（13位）
        const {livesteramEndTime, livesteramTime} = res.data; // 假设 res.data 有这两个字段
        if (timestamp_ms < livesteramTime) {
          this.liveState = 0; // 未开始
        } else if (timestamp_ms > livesteramEndTime) {
          this.liveState = 2; // 已结束
        } else {
          this.liveState = 1; // 直播中
        }
        getTeacherByUserId({userUuid: res.data.userUuid}).then(teaRes => {
          if (teaRes.code === 200) {
            this.teacherData = teaRes.data
          }
        })
      }
    })
  },
  created() {
    getListLivestream({current: 1, size: 8}).then(res => {
      if (res.code === 200) {
        this.recommendList = res.data.records
      }
    })
  },
  methods: {

    upPlayBack(message) {
      this.$alert(`${message}`, '直播数据', {
        confirmButtonText: '确定',
        callback: action => {
          sessionStorage.removeItem('previousPageData'); // 立即清除
          // this.$message({
          //   type: 'info',
          //   message: `action: ${action}`
          // });
        }
      });
    },
    // 跳转
    goCourseDetails(id) {
      this.$router.push("/liveIndex?id=" + id);
    },
    // timestampToTime(timestamp) {
    //   // 判断是10位还是13位时间戳（10位需要乘以1000）
    //   const date = new Date(
    //       timestamp.toString().length === 10
    //           ? timestamp * 1000
    //           : timestamp
    //   );
    //   const y = date.getFullYear();
    //   const MM = date.getMonth() + 1;
    //   const d = date.getDate();
    //   const h = date.getHours();
    //   const m = date.getMinutes();
    //   const s = date.getSeconds();
    //   // 补零操作
    //   const padZero = (num) => (num < 10 ? `0${num}` : num);
    //   return `${y}-${padZero(MM)}-${padZero(d)} ${padZero(h)}:${padZero(m)}:${padZero(s)}`;
    // },
    joinLive() {
      let token = JSON.parse(localStorage.getItem("USER_AUTH_INFO"))
          ? JSON.parse(localStorage.getItem("USER_AUTH_INFO"))
          : "";
      if (token && token.nickName) {
        this.$router.push({
          path: '/liveBackLook',
          query: {
            src: this.liveData.playbackUrl,
            picture: this.liveData.roomShowUrl,
            title: this.liveData.roomName
          }
        });
      } else {
        const that = this
        this.$message.error({
          title: "错误",
          message: "请先登录再尝试观看！",
          duration: 1000,
          onClose() {
            that.$router.push('/personallogin')
          }
        });
      }

    }
  }
}

</script>
